import React, {memo} from 'react';
import Dialog from 'components/Dialog';
import FormikTextField from 'components/inputs/FormikTextField';
import {Grid} from '@mui/material';
import {FormFooterButtons} from 'components/buttons/FormFooterButtons';
import * as yup from 'common/yup';
import Formik, {FormOnSubmitHelpers} from 'components/hook-form/Formik';
import {Trans, useTranslation} from 'react-i18next';
import Typography from '@mui/material/Typography';

const certNames = {
   body: 'body',
   privateKey: 'private',
   chain: 'chain',
} as const;

const validationSchema = yup.object({
   [certNames.body]: yup.string().required(),
   [certNames.privateKey]: yup.string(),
   [certNames.chain]: yup.string(),
} as const);
export type CertFormType = yup.InferType<typeof validationSchema>;

export interface CertDialogProps {
   data: {
      title: string;
      open?: boolean;
      value?: string;
      label?: string;
      info?: string;
   };
   onClose: (nameObj?: CertFormType, callbacks?: FormOnSubmitHelpers<CertFormType>) => void;
}
export const CertDialog = memo(({data, onClose: onSubmit}: CertDialogProps) => {
   const {title, value, open = true, label, info} = data;
   const onClose = React.useCallback(() => onSubmit(), [onSubmit]);
   return (
      <Dialog open={open} maxWidth="sm" header={title} close={onClose}>
         <Formik
            initialValues={validationSchema.cast({name: value})}
            initialTouched={Boolean(value) ? ['body'] : undefined}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
         >
            <CertForm cancel={onClose} label={label} info={info} />
         </Formik>
      </Dialog>
   );
});

const CertForm = ({cancel, label, info}: {label?: string; cancel: () => void; info?: string}) => {
   const {t} = useTranslation();
   return (
      <>
         <Grid container spacing={3} justifyContent="center">
            <Grid item sm={11}>
               <Typography variant="h6">{info}</Typography>
            </Grid>
            <Grid item sm={11}>
               <FormikTextField
                  autoFocus
                  name={certNames.body}
                  label={label || t('License Text')}
                  multiline
                  rows={8}
               />
               {/* <FormikTextField
                  name={certNames.privateKey}
                  label={t('Certificate private key')}
                  multiline
               />
               <FormikTextField
                  name={certNames.chain}
                  label={t('Certificate chain - optional')}
                  multiline
               /> */}
            </Grid>
         </Grid>
         <Grid container spacing={3} justifyContent="center">
            <Grid item>
               <FormFooterButtons cancel={cancel} />
            </Grid>
         </Grid>
      </>
   );
};
